module.exports = __webpack_public_path__ + "media/images/facebook-5efc5f3b858a4574fb3f09ee136fef68.svg";